<template>
  <router-view />
</template>

<script>
  /* eslint-disable */
  export default {
    name: 'App'
  }
</script>

<style lang="scss">
@import "./assets/css/app";
</style>
